import React, { FC, useContext } from 'react';
import {
  FormatCurrencies,
  FormatCurrency,
  FormatCurrencyType,
  MutedText,
} from 'shared/components/Format/Currency';
import {
  HIGH_FORMAT_CURRENCY_PRECISION,
  calculatePlatformFeeFromPrimaryAmount,
} from 'shared/utils';
import { GameActivityPaymentContext } from 'modules/game-payments/providers';
import { SystemCurrency } from '@okletsplay/core';

interface ComponentProps {
  amount: number;
  showZeroLabel?: boolean;
  zeroLabel?: string;
  showUsdEquivalent?: boolean;
}

export const GameCurrencyWithFee: FC<ComponentProps> = ({
  amount,
  showZeroLabel = true,
  zeroLabel = 'Free',
  showUsdEquivalent: originalShowUsdEquivalent,
}) => {
  const { paymentConfig, platformFeePercentage } = useContext(GameActivityPaymentContext);

  if (!paymentConfig) {
    return null;
  }

  if (!paymentConfig.isPlatformFeeApplied) {
    return (
      <FormatCurrencies
        amount={amount}
        showZeroLabel={showZeroLabel}
        zeroLabel={zeroLabel}
        showUsdEquivalent={originalShowUsdEquivalent}
        currency={paymentConfig.mainCurrency}
      />
    );
  }

  const showUsdEquivalent =
    originalShowUsdEquivalent && paymentConfig.platformFeeCurrency !== SystemCurrency.USDT;

  const platformFee = calculatePlatformFeeFromPrimaryAmount(
    amount,
    paymentConfig.exchangeRate,
    platformFeePercentage
  );

  if (showZeroLabel && !amount) return <>{zeroLabel}</>;

  return (
    <>
      <FormatCurrency
        amount={amount}
        type={FormatCurrencyType.Crypto}
        currency={paymentConfig.mainCurrency}
        maxPrecision={HIGH_FORMAT_CURRENCY_PRECISION}
      />
      <MutedText style={{ whiteSpace: 'nowrap' }}>
        {' +'}
        {showUsdEquivalent ? (
          <FormatCurrencies
            amount={platformFee}
            currency={paymentConfig.platformFeeCurrency}
            maxPrecision={HIGH_FORMAT_CURRENCY_PRECISION}
          />
        ) : (
          <FormatCurrency
            amount={platformFee}
            type={FormatCurrencyType.Crypto}
            currency={paymentConfig.platformFeeCurrency}
            maxPrecision={HIGH_FORMAT_CURRENCY_PRECISION}
          />
        )}
      </MutedText>
    </>
  );
};
